import axios from 'axios';

export async function fetchVersionRegistry() {
  const response = await axios.get(
    "https://docs.sustamizer.com/assets/ilcd-docs/VersionRegistryV3.3.0.json"
  );
  return response.data;
}